// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"561b0d18","498":"094772f3","703":"1dd5f49e"}[chunkId] + ".chunk.js";
};